export default __webpack_public_path__ + "static/media/units.602601d2.svg";